module.exports = __webpack_public_path__ + "img/empty_question.0f1605fe.png";